import { useState } from 'react'
import { useSelector } from 'react-redux'

import { selectCurrencyData } from '../selectors/selectCurrencyData'

export const useCurrencyData = (initialCurrency?: string) => {
  const { localCurrency, defaultCurrency } = useSelector(selectCurrencyData)
  const [currency, setCurrency] = useState(initialCurrency || localCurrency || defaultCurrency)

  return {
    localCurrency,
    currency,
    setCurrency,
  }
}
